import { createApi } from "@reduxjs/toolkit/query/react";
import { resourceLink } from "../../services/cpln";
import { customBaseQuery } from "./common";
import { Org } from "../../schema/types/org/entity";

export const orgApi = createApi({
  reducerPath: "orgApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Org"],
  endpoints: (builder) => ({
    getOrg: builder.query<Org, string>({
      queryFn: async (orgName) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: resourceLink("org", orgName) });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, orgName) => [{ type: "Org", id: orgName }],
    }),
  }),
});

export const { useGetOrgQuery } = orgApi;
